(function($){
	$(document).ready(function(){
        var slideM = new SliderManager($);
        var ImgBg = new ImgSfondo($);
        ImgBg.init();
        var menuMob = new MenuMobile($);
        menuMob.init();
        $('#ottimizzazione').click(function(evt){
            evt.preventDefault();
            $('#show').toggle();
        });

		$(window).resize(function() {
     	   ck_mobile();
            slideM.positions();
	 	 });
    	ck_mobile();


        slideM.positions();
	});

    function ck_mobile(event){
		// x calcolare la larghezza della scrollbar
        function measureScrollbar() {
              var $c = $("<div style='position:absolute; top:-10000px; left:-10000px; width:100px; height:100px; overflow:scroll;'></div>").appendTo("body");
              var width = $c.width() - $c[0].clientWidth;
              /*
               var dim = {
                width: $c.width() - $c[0].clientWidth,
                height: $c.height() - $c[0].clientHeight
              };
              */
              $c.remove();
              return width;
        }

        var w = $(window).width() + measureScrollbar();
        if(w>999){
            //var removeClasses = ["mobileS","mobile","tabletS","tablet","TabMob"];
            //$('body').removeClass(removeClasses.join(" ").addClass('TabDesk').addClass('desktop'));
            $('body').removeClass('mobileS').removeClass('mobile').removeClass('tabletS').removeClass('tablet').removeClass('TabMob').addClass('TabDesk').addClass('desktop');
        }else if((w>=800) && (w<=990)){
            $('body').removeClass('mobileS').removeClass('mobile').removeClass('tabletS').removeClass('desktop').addClass('TabMob').addClass('TabDesk').addClass('tablet');
        }else if((w>=768) && (w<=799)){
            $('body').removeClass('mobileS').removeClass('mobile').removeClass('desktop').addClass('tablet').addClass('TabMob').addClass('TabDesk').addClass('tabletS');
        }else if((w>=400) && (w<=767)){
            $('body').removeClass('mobileS').removeClass('tabletS').removeClass('tablet').removeClass('desktop').removeClass('TabDesk').addClass('TabMob').addClass('mobile');
        }else if(w <=399){
            $('body').removeClass('tabletS').removeClass('tablet').removeClass('desktop').addClass('mobile').removeClass('TabDesk').addClass('TabMob').addClass('mobileS');
        }
    };

})(jQuery.noConflict());
